import React from 'react'
import { newPasswordSchema, requiredString } from '@fs/identity.js'
import { object, string } from 'yup'
import { fieldNames } from '../constants'

// https://icseng.atlassian.net/wiki/display/Product/Validation+Rules+for+CIS+accounts
// https://github.com/fs-eng/identity-cis/blob/master/cis-core/src/main/java/org/familysearch/cis/validation/BaseValidator.java#L39

const renderErrorWithHelp = (errorMessage, helpMessage) => (
  <>
    {errorMessage}
    <br />
    {helpMessage}
  </>
)

export default function usePasswordValidation({ currentPasswordHelpMessage }) {
  const schema = object().shape({
    [fieldNames.currentPassword]: string().required(() =>
      renderErrorWithHelp(requiredString(), currentPasswordHelpMessage)
    ),
    [fieldNames.newPassword]: newPasswordSchema,
  })
  return schema
}
